import { type ApiHeaders } from '../types/http';
import { type ApiConfig } from '../types/api';

export const mergeHeaders = (...headers: Array<ApiHeaders | undefined>): Record<string, string> => {
  const mergedHeaders = new Headers();

  for (const currentHeaders of headers) {
    if (!currentHeaders) {
      continue;
    }

    for (const [key, value] of Object.entries(currentHeaders)) {
      mergedHeaders.set(key, value);
    }
  }

  return Object.fromEntries(mergedHeaders.entries());
};

export const mergeApiConfig = (baseConfig: ApiConfig, overrideConfig: Partial<ApiConfig>): ApiConfig => {
  return {
    ...baseConfig,
    ...overrideConfig,
    headers: mergeHeaders(baseConfig.headers, overrideConfig.headers),
  };
};
